// "Kênh nhân sự" (hợp đồng Marketing kenh-nhan-su-erp-v1, CEO chốt 16/10/2026) —
// nhân sự tự ký quy chế, khai kênh, khai video, nộp ảnh và theo dõi tiền thưởng
// của CHÍNH mình ngay trên GNPF; từ 03/11/2026 (CEO 1a · 2a) thêm lượt xem tham
// khảo, ảnh bìa video và thẻ "Phân tích kênh" xem mọi kênh toàn công ty.
//
// Bài cố ý KHÔNG kể cách tính thưởng (mốc, hệ số nằm trong quy chế Marketing gửi
// và hiện nguyên văn trên màn — chép vào đây là sai ngay khi quy chế đổi bản) và
// KHÔNG kể phòng Marketing duyệt ra sao — đó là việc của phòng khác.

import type { GuideBook } from "../types";

const EVERYONE = [
  "reception",
  "sale",
  "photo",
  "makeup",
  "assistant",
  "retouch",
  "cskh",
  "marketing",
  "accounting",
  "qc",
  "lead",
  "exec",
] as const;

export const STAFF_CHANNEL_GUIDES: GuideBook = {
  staff_channel: {
    purpose:
      "Khai kênh, khai video, theo dõi lượt xem và tiền thưởng Kênh nhân sự của bạn, và xem mọi kênh, mọi clip toàn công ty mà không phải mở màn Marketing.",
    where: [
      'Đầu trang: tên trang "Kênh nhân sự", nút "+ Khai video" và "+ Khai kênh" ở mép phải. Ngay dưới là hai thẻ "Của tôi" và "Phân tích kênh" (thẻ thứ hai chỉ hiện khi máy chủ đã nối đường đọc).',
      'Lần đầu vào hoặc khi quy chế đổi bản: khối quy chế của chương trình (bảng mốc thưởng, các điều của quy chế, cẩm nang) với nút "Tôi đồng ý" ở cuối.',
      'Hàng ô tiền: "Tổng thưởng", "Đã nhận", "Đang chờ". Ngay dưới là dải vàng "Việc kế tiếp".',
      'Máy tính: cột trái có khối "Kênh của bạn" và "Video đã khai"; cột phải có "Tiền theo tháng", "Mốc thưởng" và "Lệnh vừa gửi".',
      'Điện thoại: bốn thẻ "Kênh", "Video", "Tiền", "Mốc"; khối "Lệnh vừa gửi" ở dưới cùng.',
      'Trên từng kênh có thể có nút "Nộp ảnh chứng minh kênh"; trên từng video có thể có nút "Nộp lại bài" và "Nộp ảnh số liệu" (video máy đang tự đọc lượt xem thì nút ghi "Nộp ảnh (nếu máy chưa đọc được)").',
      'Trong khối "Tiền theo tháng", dưới bảng tháng là danh sách "Từng dòng tiền": kỳ, video, số tiền, ngày ghi và nút "Khiếu nại" (máy tính là bảng, điện thoại nằm trong thẻ "Tiền").',
      'Mỗi video có ảnh bìa bên trái và dòng "Lượt xem hôm nay" (kèm thích, bình luận, chia sẻ, giờ máy đọc) với câu "Số tham khảo — tiền tính theo số chốt ngày 30".',
      'Thẻ "Phân tích kênh": sáu ô số đầu thẻ, hàng lọc (ô tìm, "Thương hiệu", "Nền tảng", "Trạng thái", "Thời gian", "Xếp theo"), bảng "Toàn bộ kênh" (điện thoại: mỗi kênh một thẻ). Bấm một kênh mở trang riêng của kênh với nút "← Toàn bộ kênh", khối "Lượt xem tăng theo tuần", "So với cả công ty", "clip cao nhất", "clip thấp nhất", "Ngày đăng hiệu quả", "Nhận xét của AI" và "Mọi video".',
      'Trang "Của tôi" có khối nhỏ "Kênh nhân sự" — bấm vào là mở trang này.',
    ],
    howItWorks: [
      "Trang chỉ có kênh, video và tiền của chính bạn; không ai khác mở được phần của bạn ở đây, và bạn cũng không khai hộ ai được.",
      "Số trên trang do phòng Marketing giữ và gửi sang; GNPF chỉ hiện lại, không tự tính.",
      'Bấm gửi một việc (khai kênh, khai video, nộp ảnh, ký quy chế) là việc đó vào hàng chờ của Marketing — khối "Lệnh vừa gửi" ghi "Đang gửi". Khi Marketing trả lời, dòng đổi sang "Xong" hoặc "Không nhận" kèm câu của Marketing; trang tự cập nhật.',
      "Ảnh chứng minh kênh và ảnh số liệu đi thẳng sang Marketing; GNPF không giữ ảnh.",
      'Ô "Đã nhận" chỉ tính khoản Kế toán đã chi xong. Khoản đã duyệt nhưng chưa chi nằm ở "Đang chờ".',
      'Nút "Nộp ảnh số liệu" chỉ hiện khi video đã hết thời gian đo; trước đó video ghi "Chưa tới hạn".',
      "Lần đầu mở trang, máy tự xin Marketing gửi số của bạn — đợi vài phút là trang có số.",
      '"Lượt xem hôm nay" là số máy của Marketing đọc gần nhất (mỗi ngày tới khi clip tròn 30 ngày, rồi mỗi tuần tới 90 ngày) — chỉ để theo dõi. Tiền thưởng vẫn tính theo số chốt lúc clip tròn 30 ngày, nên mốc và tiền không đổi theo số này.',
      'Thẻ "Phân tích kênh" lấy số từ Marketing ngay lúc bạn mở (đi qua Center), không lưu ở GNPF: mọi kênh, mọi video, chỉ số và tiền của toàn công ty — đúng như thẻ cùng tên trên màn Marketing. Người chưa ký quy chế được ẩn tên. Thẻ chỉ để xem: không có việc duyệt, sửa thương hiệu hay đánh dấu quảng cáo.',
      'Lượt xem ở thẻ "Phân tích kênh" cũng là số máy đọc gần nhất, không phải số tính tiền. Ô "Thời gian" đổi mọi con số theo clip đăng trong khoảng đó.',
      'Nút "Khiếu nại" chỉ hiện trên dòng tiền còn trong hạn khiếu nại của quy chế; hạn ghi ngay dưới nút. Khiếu nại là một việc gửi Marketing như các việc khác — kết quả hiện ở "Lệnh vừa gửi".',
    ],
    statuses: [
      { label: "Đang gửi", meaning: "Việc bạn vừa bấm đã vào hàng chờ của Marketing, chưa có trả lời. Không cần bấm lại." },
      { label: "Xong", meaning: "Marketing đã nhận việc đó; câu bên cạnh nói bước tiếp theo." },
      { label: "Không nhận", meaning: "Marketing không nhận việc đó; câu bên cạnh nói lý do và cách sửa." },
      {
        label: "Nhãn trên kênh, video, tháng tiền",
        meaning: 'Chữ trong các nhãn màu (ví dụ "Đã xác minh", "Đã duyệt", "Đã chi ngày …") là chữ Marketing gửi — đọc đúng như ghi.',
      },
      { label: "Mốc thưởng tô xanh / vàng", meaning: "Xanh: mốc video của bạn đã đạt. Vàng: mốc kế tiếp của video đang đo." },
      {
        label: "Lượt xem hôm nay: máy chưa đọc được",
        meaning: "Máy chưa đọc được số của video này lần nào (video mới đăng, riêng tư hoặc nền tảng chưa cho đọc). Không phải 0 lượt xem.",
      },
      { label: "không công khai", meaning: "Nền tảng không công khai số đó (ví dụ lượt xem Facebook trang cá nhân) — không tính là 0." },
      { label: "chưa có số", meaning: "Kênh / video đã khai nhưng máy chưa đọc được chỉ số nào." },
      { label: "ẩn tên — chưa ký quy chế", meaning: "Chủ kênh chưa từng ký quy chế nên tên được ẩn với người khác." },
      { label: "của tôi", meaning: 'Dòng kênh của chính bạn trong thẻ "Phân tích kênh".' },
      { label: "Đã khiếu nại", meaning: "Dòng tiền này đã có khiếu nại gửi Marketing; không gửi thêm được." },
      { label: "Hết hạn khiếu nại", meaning: "Dòng tiền đã quá hạn khiếu nại của quy chế; cần hỏi thì nhắn phòng Marketing." },
    ],
    blocks: [
      {
        for: [...EVERYONE],
        title: "Bắt đầu: ký quy chế và khai kênh",
        steps: [
          'Mở mục "Kênh nhân sự" ở nhóm Của tôi.',
          'Đọc hết khối quy chế rồi bấm "Tôi đồng ý".',
          'Bấm "+ Khai kênh", chọn nền tảng, dán đường dẫn hoặc tên kênh, chọn "Kênh của tôi" hay "Kênh của công ty", bấm "Gửi khai kênh".',
          'Khi kênh ghi chưa nộp ảnh, bấm "Nộp ảnh chứng minh kênh", chọn ảnh chụp trang kênh lúc bạn đang đăng nhập kênh đó, bấm "Gửi ảnh chứng minh".',
        ],
        troubles: [
          'Trang ghi "Đang lấy số của bạn từ Marketing": đợi vài phút rồi tải lại trang.',
          'Báo "Tài khoản chưa gắn với hồ sơ nhân sự GNPF": nhờ phòng Nhân sự gắn tài khoản cho bạn.',
          '"Không nhận" kèm câu chưa có hồ sơ HRM: nhờ phòng Nhân sự kiểm hồ sơ của bạn trên HRM.',
          "Chọn ảnh mà báo chỉ nhận PNG hoặc JPG: chụp lại màn hình rồi chọn ảnh đó.",
        ],
      },
      {
        for: [...EVERYONE],
        title: "Khai video, nộp lại bài, nộp ảnh số liệu",
        steps: [
          'Bấm "+ Khai video", chọn kênh đã xác minh, dán đường dẫn video, chọn ngày giờ đăng, bấm "Gửi khai video".',
          'Video bị trả lại: đọc lý do Marketing ghi dưới video, sửa video, bấm "Nộp lại bài" trước hạn ghi bên cạnh.',
          'Hết thời gian đo: bấm "Nộp ảnh số liệu", chọn nguồn số liệu, gõ lượt xem đúng như trong ảnh, chọn ảnh chụp màn hình số liệu, bấm "Gửi ảnh số liệu".',
          'Theo dõi tiền ở "Tiền theo tháng": mỗi tháng có nhãn chặng cho biết tiền đang ở đâu.',
          'Thấy một dòng tiền sai: ở "Từng dòng tiền" bấm "Khiếu nại" trên đúng dòng đó, ghi lý do, bấm "Gửi khiếu nại".',
        ],
        troubles: [
          '"+ Khai video" báo cần kênh đã xác minh: nộp ảnh chứng minh kênh trước và đợi Marketing xác minh.',
          'Đứng mãi ở "Đang gửi" quá một ngày: báo bộ phận kỹ thuật, đừng gửi trùng việc mới.',
          'Dòng tiền không có nút "Khiếu nại" mà ghi "Hết hạn khiếu nại": đã quá hạn quy chế — nhắn phòng Marketing.',
          '"Gửi khiếu nại" bị mờ: ô "Lý do khiếu nại" còn trống.',
        ],
      },
      {
        for: [...EVERYONE],
        title: 'Xem mọi kênh ở thẻ "Phân tích kênh"',
        steps: [
          'Bấm thẻ "Phân tích kênh".',
          'Gõ tên kênh hoặc tên người vào ô tìm (gõ không dấu cũng được), hoặc chọn "Thương hiệu", "Nền tảng", "Trạng thái", "Thời gian"; chọn "Xếp theo" để đổi thứ tự.',
          'Bấm một kênh để mở trang riêng của kênh: xem lượt xem theo tuần, so với cả công ty, clip cao nhất / thấp nhất, ngày đăng hiệu quả, nhận xét của AI và mọi video kèm tiền.',
          'Bấm "← Toàn bộ kênh" để quay lại bảng.',
        ],
        troubles: [
          'Thẻ báo "Chưa đọc được Phân tích kênh": bấm "Thử lại" sau ít phút; vẫn vậy thì báo bộ phận kỹ thuật. Thẻ "Của tôi" vẫn dùng bình thường.',
          'Không thấy thẻ "Phân tích kênh": máy chủ GNPF chưa nối đường đọc — báo bộ phận kỹ thuật.',
          "Ảnh bìa hiện ô xám: video chưa có ảnh bìa hoặc tạm chưa tải được — không ảnh hưởng số và tiền.",
        ],
      },
    ],
    askWho: "Hỏi về kênh, video, tiền thưởng thì nhắn phòng Marketing; trang báo lỗi lạ thì báo bộ phận kỹ thuật.",
  },
};
